import { render, staticRenderFns } from "./SemenDisposal.vue?vue&type=template&id=0a3d3270&scoped=true&"
import script from "./SemenDisposal.vue?vue&type=script&lang=js&"
export * from "./SemenDisposal.vue?vue&type=script&lang=js&"
import style0 from "./SemenDisposal.vue?vue&type=style&index=0&id=0a3d3270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d3270",
  null
  
)

export default component.exports